import * as persistanceKeys from '@web-platform/shared-universal-constants/src/persistanceKeys';
import { tryGetValue } from '@web-platform/shared-universal-utils-frontend/src/helpers/sessionStorage';

import { ECO_FILTER_CHANGED, FILTERS_RESET } from '../../../../../../actions/filters';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { EcoFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/eco';

export const INITIAL_STATE: EcoFilterState = { checked: false };
const filtersInSession = () => tryGetValue(persistanceKeys.FILTERS, { eco: INITIAL_STATE });
const storedStateFilters = () => {
  const sessionStorage = filtersInSession();
  return sessionStorage && sessionStorage.eco ? sessionStorage.eco : INITIAL_STATE;
};

export const createEcoReducer =
  (getInitialState: () => EcoFilterState = storedStateFilters) =>
  (state: EcoFilterState = getInitialState(), action: Action): EcoFilterState => {
    switch (action.type) {
      case ECO_FILTER_CHANGED: {
        return { checked: action.payload.checked };
      }

      case FILTERS_RESET: {
        return INITIAL_STATE;
      }

      default:
        return state;
    }
  };

export default createEcoReducer();
export const get = (state: EcoFilterState): EcoFilterState => state;
